﻿export class RESTError {
    public Message: string;
    public Aborted: boolean;

    constructor(jqXHR: JQueryXHR) {
        this.Aborted = jqXHR.statusText == 'abort';
        if (jqXHR.responseJSON && 'Message' in jqXHR.responseJSON) {
            this.Message = jqXHR.responseJSON.Message;
        } else {
            this.Message = jqXHR.statusText;
        }
    }
}